import { render, staticRenderFns } from "./PopupDialog.vue?vue&type=template&id=57bc8bcf&scoped=true&"
import script from "./PopupDialog.vue?vue&type=script&lang=js&"
export * from "./PopupDialog.vue?vue&type=script&lang=js&"
import style0 from "./PopupDialog.vue?vue&type=style&index=0&id=57bc8bcf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57bc8bcf",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('57bc8bcf')) {
      api.createRecord('57bc8bcf', component.options)
    } else {
      api.reload('57bc8bcf', component.options)
    }
    module.hot.accept("./PopupDialog.vue?vue&type=template&id=57bc8bcf&scoped=true&", function () {
      api.rerender('57bc8bcf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2Q06TGqo7HFwH/JS/comp/PopupDialog.vue"
export default component.exports